import memoizeOne from 'memoize-one';

import { getSuccessfulResultOrThrow } from '@atlassian/commerce-ccp-gateway-client/error-wrappers';
import type { EntitlementDetails } from '@atlassian/commerce-ccp-gateway-client';
import { entitlementsDetails_get_byEntitlementId_v1 } from '@atlassian/commerce-ccp-gateway-client';

import { getApolloClient } from '@confluence/graphql';
import { cfetch } from '@confluence/network';

import { CcpEntitlementIdQuery } from './graphql/CcpEntitlementIdQuery.graphql';

const memoizedEntitlementsDetails_get_byEntitlementId_v1 = memoizeOne(
	entitlementsDetails_get_byEntitlementId_v1,
	(
		[
			{
				pathParameters: { entitlementId: newEntitlementId },
			},
		],
		[
			{
				pathParameters: { entitlementId: lastEntitlementId },
			},
		],
	) => {
		return newEntitlementId === lastEntitlementId;
	},
);

export const getCurrentEntitlementDetails = async (): Promise<EntitlementDetails> => {
	// get current tenant's entitlement id
	const apolloClient = getApolloClient();
	const entitlementIdQuery = await apolloClient.query({
		query: CcpEntitlementIdQuery,
	});
	const entitlementId = entitlementIdQuery?.data?.siteConfiguration?.ccpEntitlementId || '';

	if (!entitlementId) throw new Error('empty entitlementId');

	// get the entitlement details
	const entitlementDetails = getSuccessfulResultOrThrow(
		await memoizedEntitlementsDetails_get_byEntitlementId_v1({
			fetch: cfetch,
			pathParameters: {
				entitlementId,
			},
		}),
	);

	return entitlementDetails as EntitlementDetails;
};
